export default {
  name: 'Prevention',
  description: 'Cost to Prevent Errors Prior to Processing / In Process Controls',
  completed: false,
  color: '#008FFB',
  banner: 'parallax-red.jpg',
  costs: [
    {
      name: 'Inspection',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Training',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Procedure Development',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
    {
      name: 'Prior to Processing',
      color: '',
      deleted: false,
      verified: false,
      visible: true,
      subCosts: [
        {
          name: 'Design Engineering',
          value: null
        },
        {
          name: 'Purchasing',
          value: null
        },
        {
          name: 'Production',
          value: null
        },
        {
          name: 'Accounting',
          value: null
        },
        {
          name: 'Finance',
          value: null
        },
        {
          name: 'Quality',
          value: null
        },
        {
          name: 'Materials',
          value: null
        },
        {
          name: 'Sales & Marketing',
          value: null
        },
        {
          name: 'Other',
          value: null
        }
      ],
    },
  ]
};